export default __webpack_public_path__ + "static/assets/79a644579518611a7b397f85a32cfb85.svg";